import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { RouterModule } from '@angular/router';
import { ProfileResolver } from './resolver/profile.resolver';
import { SearchPlaceComponentModule } from './components/search-place/search-place.module';
import { DialogCommerceModule } from 'src/app/shared/components/dialog-commerce/dialog-commerce.module';
import { MaterialModule } from 'src/app/core/material/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { BranchesComponent } from './components/branches/branches.component';
import { ResponsibleComponent } from './components/responsible/responsible.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { CreateEditBranchComponent } from './components/create-edit-branch/create-edit-branch.component';
import { CreateEditResponsibleComponent } from './components/create-edit-responsible/create-edit-responsible.component';
import { BranchInfoComponent } from '../my-commerce/components/branch-info/branch-info.component';
import { CreateCashiersComponent } from '../my-commerce/components/create-cashier/create-cashiers.component';
import { ConfirmarDialogModule } from 'src/app/shared/components/confirmar-dialog/confirmar-dialog.module';
import { MatMenuModule } from '@angular/material/menu';
import { SubscripcionesResolver } from './resolver/suscripciones.resolver';
import { PlanesTarifasResolver } from '../my-commerce/resolver/planes-tarifas.resolver';
import { MyCommerceComponent } from './my-commerce.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CommunicationService } from 'src/app/core/services/communication.service';
import { TarifarioService } from 'src/app/core/services/tarifario.service';
import { AuthGuard } from 'src/app/core/guards/auth.guard';
import { Permissions } from 'src/app/core/enums/permissions.enum';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';

@NgModule({
  declarations: [
    MyCommerceComponent,
    BranchesComponent,
    ResponsibleComponent,
    CreateEditBranchComponent,
    CreateEditResponsibleComponent,
    BranchInfoComponent,
    CreateCashiersComponent
  ],
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: MyCommerceComponent,
        canActivate: [AuthGuard],
        resolve: {
          profilePictUrl: ProfileResolver,
          subscripciones: SubscripcionesResolver,
          planes: PlanesTarifasResolver
        },
        data: {
          breadcrumb: 'components.menu.profile',
          permission: [Permissions.MI_COMERCIO],
          status: true
        }
      },
      {
        path: 'my-commerce/branches/:action',
        component: CreateEditBranchComponent,
        canActivate: [AuthGuard],
        data: {
          paramkey: 'action',
          entity: 'branch_office',
          permission: [Permissions.MI_COMERCIO]
        }
      },
      {
        path: 'my-commerce/branch',
        component: MyCommerceComponent,
        data: {
          permission: [Permissions.MI_COMERCIO]
        }
      },
      {
        path: 'my-commerce/responsible/:action',
        component: CreateEditResponsibleComponent,
        canActivate: [AuthGuard],
        data: {
          paramkey: 'action',
          entity: 'branch_manager',
          permission: [Permissions.MI_COMERCIO]
        }
      },
      {
        path: 'my-commerce/cashiers/:action',
        component: CreateCashiersComponent,
        canActivate: [AuthGuard],
        data: {
          paramkey: 'action',
          entity: 'cashier',
          permission: [Permissions.MI_COMERCIO]
        }
      }
    ]),
    SearchPlaceComponentModule,
    DialogCommerceModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    MatFormFieldModule,
    MatInputModule,
    SharedModule,
    ConfirmarDialogModule,
    MatMenuModule,
    NgxPaginationModule,
    TranslateModule.forChild({
      isolate: false
    }),
    NgxPaginationModule,
    NgxMaskDirective,
    NgxMaskPipe
  ],
  providers: [
    CommunicationService,
    SubscripcionesResolver,
    PlanesTarifasResolver,
    TarifarioService,
    ProfileResolver,
    TranslateService
  ]
})
export class MyCommerceModule {}
